// extracted by mini-css-extract-plugin
export default {"WeatherForecast":"WeatherForecast_WeatherForecast__NcIHc"};